export default {
  title: 'Professional experience',
  images:[
    {
      title: 'Commercial and Production Industry',
      img: require('@/assets/iconos/industria_comercial.png')
    },
    {
      title: 'Manufacturing Industry and Exporters of all Nature',
      img: require('@/assets/iconos/industria_manufacturera.png')
    },
    {
      title: 'Service Companies',
      img: require('@/assets/iconos/companias_servicios.png')
    },
    {
      title: ' Agro-commercial',
      img: require('@/assets/iconos/agro_comerciales.png')
    },
    {
      title: 'Insurance, Financial, Banks, Trusts, among others',
      img: require('@/assets/iconos/aseguradoras.png')
    },
    {
      title: 'Non-profit organizations',
      img: require('@/assets/iconos/ong.png')
    },
    {
      title: 'Warehouses and Free Zones',
      img: require('@/assets/iconos/almacenadoras.png')
    },
    {
      title: 'Saving and Credit Unions',
      img: require('@/assets/iconos/cooperativas.png')
    },
    {
      title: 'Construction and leasing companies',
      img: require('@/assets/iconos/constructoras.png')
    }
  ],
  control:{
    title: 'Quality Assurance',
    description: 'We work with strict quality standards and rigor, which allow us to optimize risk management, preserve the business and contribute to the construction of reliable businesses.',
    description2: 'Our multidisciplinary team, through its values and actions, under a constant line of training, positions us at a high level.'
  },
  responsibles: {
    title: 'Responsibles',
    description: 'Our CEO, Jorge A. Román García is in charge of quality guidelines by giving our clients the confidence needed, and being responsible of dealing with high-value issues. His 40 years of experience attest to his extensive experience and an impeccable professional record.',
    description2: 'Availability and knowledge make him the right person to lead a work team comprised of professionals who expand their experience in an adequate, honest, and reliable practice. Román García is the one who fully enforces professional responsibility, internal and external policy for the peace of mind of our clients.'
  },
  equipment:{
    title: 'Work Team',
    description: 'The main objective of our practice is to provide a quality service, adapted to the needs of the client. This implies attending to each of our jobs, we structure a team with clearly defined responsibilities.',
  },
  partner: {
    title: 'Partner in Charge',
    description: 'The leader in charge of the services, execution, and communication with clients is Jorge Román Pineda. His leadership and professionalism guide the team in order to carry out a quality work.',
    description2: 'He is also in charge of handling specific situations, problem solving, supervision and direction, with the support of the managers of each area.'
  }
}



// WEBPACK FOOTER //
// ./src/text/en/experience.js